import { useCallback } from 'react';
import { useStandaloneUsageTracker } from '../context/UsageTrackerContext';
import { useMergeTrackEventProps } from './useMergeTrackEventProps';
export function useTrackMarketplaceEvent(beacon = false) {
  const standaloneTracker = useStandaloneUsageTracker(beacon);
  const mergeEventProps = useMergeTrackEventProps();
  return useCallback(({
    namespace,
    eventName,
    eventProps
  }) => {
    standaloneTracker.track(namespace, eventName, mergeEventProps(eventProps));
  }, [mergeEventProps, standaloneTracker]);
}